export const NoPermissions = (): JSX.Element => {
  // todo: change design
  return <div>No Permissions</div>;
};
